module.exports = __webpack_public_path__ + "img/FF_Asset_Info_Web_5.52e91adf.png";